"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var void_1 = __importDefault(require("html-tags/void"));
/**
 * List of tags having optional closing tag
 */


var optionalVoidHtmlTags = ['li'];
var min = Math.min,
    max = Math.max;

var HtmlSubstringError =
/** @class */
function (_super) {
  __extends(HtmlSubstringError, _super);

  function HtmlSubstringError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return HtmlSubstringError;
}(Error);

var DEFAULT_OPTIONS = {
  breakWords: true,
  suffix: null
};

var isLetter = function isLetter(input) {
  return input && input.toLowerCase() !== input.toUpperCase();
};

var isNumber = function isNumber(input) {
  return '0123456789'.indexOf(input) !== -1;
};

var isWhitespace = function isWhitespace(input) {
  return ' \t\r\n'.indexOf(input) !== -1;
};

var isVoidTag = function isVoidTag(tag) {
  return void_1.default.indexOf(tag) !== -1;
};

var isOptionalVoidTag = function isOptionalVoidTag(tag) {
  return optionalVoidHtmlTags.indexOf(tag) !== -1;
};

var haveToHaveClosingTag = function haveToHaveClosingTag(tag) {
  return !(isVoidTag(tag) || isOptionalVoidTag(tag));
};
/**
 * @param source Source HTML
 * @param length Visible characters (everything but HTML tags) limit
 * @param options Options object
 *
 * @returns stripped source by length characters
 */


function html_substring(source, length, options) {
  if (options === void 0) {
    options = DEFAULT_OPTIONS;
  }

  var opts;

  if (typeof options === 'string') {
    opts = __assign({}, DEFAULT_OPTIONS, {
      suffix: options
    });
  } else {
    opts = __assign({}, DEFAULT_OPTIONS, options);
  }

  var current = 0; // current text length

  var i = 0; // current source position

  var chars = Array.from(source); // Split the string to array of characters

  var openTag = function openTag() {
    var tag = '';
    var other = '';
    var c = '';
    var tagStart = i;

    while (i < chars.length) {
      c = chars[i++];

      if (!isLetter(c) && !isNumber(c)) {
        break;
      }

      tag += c;
    }

    if (tag.length > 0 && i < chars.length && c !== '>') {
      other += c;

      while (i < chars.length) {
        c = chars[i++];

        if (c === '>') {
          break;
        }

        other += c;
      }
    }

    if (tag.length === 0 || c !== '>') {
      cw.push('<');
      i = tagStart;
      return null;
    }

    return [tag, other];
  };

  var closeTag = function closeTag() {
    var tag = '';
    var c;

    while (i < chars.length) {
      c = chars[i++];

      if (c === '>') {
        break;
      }

      tag += c;
    }

    return tag;
  };

  var c; // current character

  var openedQueue = []; // nonflushed open tags

  var closeQueue = []; // list of tags to be closed

  var result = '';

  var openTags = function openTags(onlyVoid) {
    if (onlyVoid === void 0) {
      onlyVoid = false;
    }

    while (true) {
      var value = openedQueue.shift();

      if (!value) {
        break;
      }

      var tag = value[0],
          other = value[1];
      var isVoid = isVoidTag(tag);
      var isOptionalVoid = isOptionalVoidTag(tag);
      var isXHTMLClosed = other[other.length - 1] === '/';

      if (onlyVoid && !(isVoid || isXHTMLClosed)) {
        openedQueue.unshift([tag, other]);
        break;
      }

      result += '<';
      result += tag;
      result += other;
      result += '>';

      if (!(isVoid || isOptionalVoid || isXHTMLClosed)) {
        closeQueue.push("</" + tag + ">");
      }
    }
  };

  var cw = []; // current word

  var cwEmpty = true;
  var flushWord = opts.breakWords ? function () {
    if (cw.length === 0) {
      return true;
    }

    var addable = max(min(length - current, cw.length), 0);

    if (addable === 0) {
      return false;
    }

    openTags();
    result += cw.slice(0, addable).join('');
    current += addable;
    cw.splice(0, addable);
    return true;
  } : function () {
    if (cw.length === 0) {
      return true;
    }

    if (current + cw.length <= length) {
      openTags();
      result += cw.join('');
      current += cw.length;
      cw.length = 0;
      return true;
    }

    return false;
  };

  mainloop: while (current < length && i < chars.length) {
    c = chars[i++];

    switch (c) {
      case '<':
        if (!flushWord()) {
          break mainloop;
        } // there's tag


        switch (chars[i]) {
          case '!':
            {
              if (chars[i + 1] === '-' && chars[i + 2] === '-') {
                // comment
                i += 2;

                while (chars[i] !== '-' && chars[i + 1] !== '-' && chars[i + 2] !== '>') {
                  ++current;
                  result += chars[i++];
                }

                i += 2;
              } else {
                ++current;
                result += '<';
              }

              break;
            }

          case '/':
            {
              // We should flush opened tags queue since we are going to close a tag just now
              openTags();
              var offset_1 = i - 1;
              ++i;
              var tag = closeTag();
              var success = false; // if the tag doesn't need to be closed, then just print it

              if (haveToHaveClosingTag(tag)) {
                while (closeQueue.length !== 0) {
                  success = closeQueue.pop() === "</" + tag + ">";

                  if (success) {
                    break;
                  }
                }

                if (!success) {
                  throw new HtmlSubstringError("Unexpected closing tag '" + tag + "' on offset " + offset_1);
                }
              }

              result += '</';
              result += tag;
              result += '>';
              break;
            }

          default:
            {
              // open tag
              var tag = openTag();

              if (tag !== null) {
                openedQueue.push(tag);
              }

              break;
            }
        }

        break;

      case '&':
        var offset = i - 1;
        result += '&';
        ++current;

        while (i < chars.length) {
          var c_1 = chars[i++]; // result += c

          if (isWhitespace(c_1)) {
            i = offset + 1;
            break;
          }

          if (c_1 === ';') {
            result += chars.slice(offset + 1, i).join('');
            break;
          }
        }

        break;

      default:
        if (!isLetter(c) && !cwEmpty) {
          cwEmpty = true;

          if (!flushWord()) {
            break mainloop;
          }
        }

        if (!isWhitespace(c)) {
          cwEmpty = false;
        }

        cw.push(c);
    }
  }

  openTags(true);
  var flushed = flushWord();
  closeQueue.reverse();
  result = [result].concat(closeQueue).join('');

  if (!flushed) {
    var suffix = opts.suffix;

    if (suffix !== null) {
      if (typeof suffix === 'function') {
        suffix = suffix();
      }

      result += suffix;
    }
  }

  return result;
}

exports.html_substring = html_substring;
exports.default = html_substring;